import React from "react"

export default ({ title = "Tab", children, path = "tab" }) => {
    return (
        <div>
            {children}
        </div >
    )
}